import React, { useState, useEffect } from 'react';

import './styles.css';

import { useParams } from 'react-router';

import loadTextTest from '../../../functions/loadTextTest';

import studentsServices from '../../../services/academy/studentsServices';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import StudentProfileCard from './StudentProfileCard';
import StudentClassCard from './StudentClassCard';
import StudentDocumentsCard from './StudentDocumentsCard';
import StudentPaymentsCard from './StudentPaymentsCard';
import StudentNotificationsCard from './StudentNotificationsCard';
import ActivityIndicator from '../../../components/ActivityIndicator';

export default function Student(props) {
    const params = useParams();
    const [studentInfos, setStudentInfos] = useState({});
    const [haveNewDocument, setHaveNewDocument] = useState(true);
    const [fetching, setFetching] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);



    function verifyIsAdmin() {
        setIsAdmin(props.history.location.pathname.includes("admin"));

    }

    useEffect(() => {
        verifyIsAdmin();

        readStudentInfos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    async function readStudentInfos() {
        const response = await studentsServices.getStudentInfos(params.id);
        setFetching(false);
        if (response.status === 200) {
            setStudentInfos(response.data);
        } else
            alert("Erro ao ler informações de aluno, tente novamente!");
    };

    return (
        <MainView currentPage={isAdmin ? 'academies' : 'students'} adminMenu={isAdmin} coachMenu={props.coachMode}>
            <NavHistory navPages={['Alunos', loadTextTest(studentInfos.nome)]} />
            {
                !fetching ?
                    <div className='student-page-cards'>
                        <div className='student-page-cards-group'>
                            <StudentProfileCard isAdmin={isAdmin} academyId={params.academyId} studentInfos={studentInfos} coachMode={props.coachMode} />
                            {
                                props.coachMode ?
                                    [] :
                                    <StudentDocumentsCard
                                        studentId={studentInfos.id}
                                        haveNewDocument={haveNewDocument}
                                        setHaveNewDocument={setHaveNewDocument}
                                    />
                            }
                            <StudentNotificationsCard studentId={studentInfos.id} />
                        </div>
                        <div className='student-page-cards-group'>
                            {studentInfos.user && studentInfos.user.ativo ?
                                <StudentClassCard studentInfos={studentInfos} studentId={studentInfos.id} />
                                :
                                null
                            }
                            {
                                props.coachMode ?
                                    [] :
                                    <StudentPaymentsCard
                                        paid
                                        studentId={studentInfos.id}
                                        studentInfos={studentInfos}
                                        setHaveNewDocument={setHaveNewDocument}
                                    />
                            }
                        </div>
                    </div>
                    : <ActivityIndicator />
            }
        </MainView>
    )
}